module.exports = __webpack_public_path__ + "static/img/gonganbeihao.5dff8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gonganbeihao.png
// module id = U/qv
// module chunks = 21